<template>
  <b-list-group-item
    class="d-flex justify-content-between align-items-center mb-1 small pointer"
    @click="processContraction()"
  >
    <span v-text="contraction.contraction" :class="{'strike-through' : contraction.resolved_at}"></span>

    <div class="d-flex justify-content-end align-items-center h-100">
      <span v-text="contraction.date_human" class="contraction-date mr-2"></span>

      <b-button
        size="sm"
        variant="outline-danger"
        @click.stop="deleteContraction()"
      >
        <i class="fas fa-trash-alt"></i>
      </b-button>
    </div>
  </b-list-group-item>
</template>

<script>
import axios from 'axios';
export default {
  name: "HealingLogItem",
  components: {},
  props: {
    contraction: {
      type: Object,
      default: () => { return  {}}
    }
  },
  data() {return {}},
  computed: {
  },
  methods: {
    processContraction() {
      axios({
        method: 'post',
        url: `${this.$store.state.api_url}contractions/toggleResolve/${this.contraction.id}`,
      })
        .then(() => this.$emit('refreshFeelings'));
    },
    deleteContraction() {
      axios({
        method: 'post',
        url: `${this.$store.state.api_url}contractions/delete/${this.contraction.id}`,
      })
        .then(() => this.$emit('refreshFeelings'))
    },
  },
  mounted() {},
  watch: {}
}
</script>

<style>
.strike-through {
  text-decoration: line-through;
}
.contraction-date {
  min-width: 30%;
}
</style>
